import React, { useEffect, useRef, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FormattedMessage } from "react-intl";
import { AutoComplete, Input, InputNumber, Switch, Tooltip } from "antd";
import moment from "moment";
import numeral from "numeral";

import { withHoldingDetailFields, withHoldingDetailFieldsInps } from "./drawerConstants";
import { useDispatch, useSelector } from "react-redux";
import { VaporDatePicker } from "../../../vapor";
import { getWithholdingEditableFields, getWithholdingNonEditableFields, getWithholdingsList, updateWithholding } from "../../../../store/actions/precog/withholding";

const ContentWitholding = ({ draftId, withholdingDrawer, setWithHoldingDrawer,
  setEditable,
  withholdingUuId, drawerContentSwitch, isReadOnly, modifiedFields,
  editableDataSet, nonEditableDataSet, setModifiedFields, totalTaxable }) => {
  const withHoldings = useSelector(state => state.precog.withHoldings?.data?.reasons);
  const dispatch = useDispatch();
  const [reasonsList, setReasonsList] = useState([]);

  const reasonAutocomplete = useRef();

  useEffect(() => {
    if (!withHoldings) return;
    const optionReasons = [];
    withHoldings.forEach((el )  => {      
      optionReasons.push({
        // options: el.description?.charAt(0)?.toUpperCase() + el.description?.slice(1).toLocaleLowerCase(),
        label: el.description?.charAt(0)?.toUpperCase() + el.description?.slice(1).toLocaleLowerCase(), 
        value: `${el.code} - ${el.description}`});
    });
    setReasonsList(optionReasons);
  }, [withHoldings]);

  const WithHoldingDrawerField = ({ children, label, field, width = "50%", position = "left" }) => {
    return (
      <div className={"precog-withholding-drawer-form-item " + position} style={{ width: width, position: "relative" }}>
        <div className="precog-withholding-drawer-form-label">
          <div className="precog-withholding-drawer-form—label-text" style={{ marginBottom: 0 }}>
            {label}
          </div>
          <div className="precog-withholding-drawer-form—label-tooltip">
            {field?.tooltip && (
              <Tooltip 
                color={"rgb(0, 80, 117)"}
                placement="leftBottom" title={<FormattedMessage id={`preCog.withholdingsTab.drawer.fields.tooltips.${field?.id}`} />}>
                <FontAwesomeIcon icon={("fas", "info-circle")} />
              </Tooltip>
            )}
          </div>
        </div>
        <div className="precog-withholding-drawer-form—field">{children}</div>
      </div>
    );
  };

  const formatDate = (value) => {

    if (typeof (value) === "string"){
      return moment(value);
    } 
    return moment.unix(value);
    
  };

  const renderFormItem = (field) => {
    const dateFormatList = ["DD/MM/YYYY", "DD/MM/YY", "DD-MM-YYYY", "DD-MM-YY", "DDMMYYYY", "DDMMYY"];    
    switch (field?.type) {
    case "number":
      
      return (
        <InputNumber
          className="precog-withholding-drawer-inputCustom"
          value={editableDataSet[field?.id] ? editableDataSet[field?.id] : nonEditableDataSet?.[field?.id]}
          disabled={isReadOnly ? true : field?.readOnly}
          formatter={(value) => {
            if (field?.format === "currency") {
              return `${numeral(Math.abs(value)).format("0,0.00")} €`;
            } else if (field?.format === "percentage") {
              return `${value || "-"} %`;
            } 
            return numeral(Math.abs(value)).format("0,0.00");
            
          }}
          onBlur={() => {                                    
            setModifiedFields({ ...modifiedFields, [field?.id]: editableDataSet[field?.id] });
            dispatch(updateWithholding(
              draftId,
              withholdingUuId,
              {
                cashContribution: editableDataSet["cashContribution"],
                description: editableDataSet["description"],
                reasonId: editableDataSet["reasonId"],
                cuReason: editableDataSet["cuReason"],
                withholdingRate: editableDataSet["withholdingRate"],
                totalNetAmount: totalTaxable,
                notIncomeAmount: editableDataSet["notIncomeAmount"]             
              }
            )).then(() => {                
              dispatch(getWithholdingsList(draftId));
              dispatch(getWithholdingEditableFields(draftId,
                withholdingUuId)).then(res => setEditable(res)).then(() => {    
                     
                dispatch(getWithholdingNonEditableFields({...withholdingDrawer, totalNetAmount: totalTaxable})).then(() =>{
                  setIsLoadingDrawer(false);
                });
              });
            });
            
          }}
          onChange={(e) => {       
            editableDataSet[field?.id] = e;     
            setEditable(editableDataSet);    
          }}
          placeholder="0,00"
          parser={(value) => value.replace(/€\s?|(\.*)/g, "").replace(",", ".")}
        />
      );
    case "date":
      return (
        <VaporDatePicker
          format={dateFormatList}
          getPopupContainer={(trigger) => trigger.parentNode}
          className="precog-withholding-drawer-dateCustom"
          disabled={isReadOnly ? true : field.readOnly}
          value={field.readOnly ? formatDate(nonEditableDataSet[field.id]) : editableDataSet[field.id] ? formatDate(editableDataSet[field.id]) : nonEditableDataSet?.[field?.id] ?  formatDate(nonEditableDataSet?.[field?.id]) : null}
          onChange={e => {
            // editableDataSet[field.id] = e.format("X");
            editableDataSet[field.id] = parseInt(e.format("X"));
            setModifiedFields({ ...modifiedFields, [field.id]: e.format("X") });
            dispatch(updateWithholding(
              draftId,
              withholdingUuId,
              {
                [field.id]: e.format("X")               
              }
            )).then(() => {                
              dispatch(getWithholdingsList(draftId));
              dispatch(getWithholdingEditableFields(draftId,
                withholdingUuId)).then(res => setEditable(res)).then(() => {                      
                dispatch(getWithholdingNonEditableFields({...withholding, totalNetAmount: totalTaxable})).then(() =>{
                  setIsLoadingDrawer(false);
                });
              });
            });

          }}
        />
      );
    default:
      
      return (
        <Input
          className="inputCustom drawer-inputCustom"
          disabled={isReadOnly ? true : field?.readOnly}
          defaultValue={renderFormatValue(field, editableDataSet?.[field?.id] ? editableDataSet?.[field?.id] : nonEditableDataSet?.[field?.id])}
          onBlur={(e) => {            
            editableDataSet[field?.id] = e.target.value;
            setModifiedFields({ ...modifiedFields, [field?.id]: e.target.value });
            dispatch(updateWithholding(
              draftId,
              withholdingUuId,
              {
                [field.id]: e.target.value               
              }
            )).then(() => {                
              dispatch(getWithholdingsList(draftId));
              dispatch(getWithholdingEditableFields(draftId,
                withholdingUuId)).then(res => setEditable(res)).then(() => {                      
                dispatch(getWithholdingNonEditableFields({...withholding, totalNetAmount: totalTaxable})).then(() =>{
                  setIsLoadingDrawer(false);
                });
              });
            });
          }}
        />
      );
    }
  };

  const renderFormatValue = (field, value) => {
    switch (field?.type) {
    case "number":
      if (field?.format === "currency") {
        return `${numeral(Math.abs(value)).format("0,0.00")} €`;
      } else if (field?.format === "percentage") {
        return `${value || "-"} %`;
      } 
      return numeral(Math.abs(value)).format("0,0.00");
      
    default:
      return value;
    }
  };

  const renderInputOrInfo = (field) => {    
    // se non ho campo creo un div nullo per dare l'ingombro
    if (!field) return <div style={{ minHeight: "22px" }}></div>;

    // al momento il type pur essendo non editabile viene mandato con gli editabili. Misteri del BE
    if (field.conditionType && field.conditionType !== editableDataSet["type"]?.replace(/_/g, "")) return undefined;

    if (field?.readOnly || isReadOnly) {
      /** Purtroppo la regola non è gestibile in modo migliore */
      if (field.conditionType){
        return (
          <div>
            <FormattedMessage id={`preCog.withholdingsTab.drawer.fields.${field?.id}`} />{" "}
            <span style={{ fontWeight: "bold" }}>{`: ${renderFormatValue(field, editableDataSet["amount"])}`}</span>
          </div>
        );
      } else if (!field?.notZero || (field?.notZero && Math.abs(nonEditableDataSet?.[field?.id]) > 0)) {
        return (
          <div>
            <FormattedMessage id={`preCog.withholdingsTab.drawer.fields.${field?.id}`} />{" "}
            <span style={{ fontWeight: "bold" }}>{`: ${renderFormatValue(field, nonEditableDataSet?.[field?.id] || editableDataSet?.[field?.id])}`}</span>
          </div>
        );
      } else if (field?.notZero){
        // se è fallito perché il campo è taggato field?.notZero allora non devo visualizzare
        return null;
      } 
    }
    if (field?.type === "causale"){
      return (
        <WithHoldingDrawerField
          field={field}
          position={"left"}
          width={"100%"}
          label={<FormattedMessage id={`preCog.withholdingsTab.drawer.fields.${field?.id}`} />}
        >
          <AutoComplete
            ref={reasonAutocomplete}
            allowClear={true}
            getPopupContainer={trigger => trigger.parentNode}
            // defaultValue={`${editableDataSet?.["reasonId"]} - ${editableDataSet?.["description"]?.charAt(0)?.toUpperCase() + editableDataSet?.["description"]?.slice(1).toLocaleLowerCase()}`}
            defaultValue={editableDataSet?.["description"]?.charAt(0)?.toUpperCase() + editableDataSet?.["description"]?.slice(1).toLocaleLowerCase()}
            options={reasonsList}
            style={{ width: "100%" }}
            filterOption={(inputValue, option) => {                                      
              // if (inputValue === `${editableDataSet?.["reasonId"]} - ${editableDataSet?.["description"]?.charAt(0)?.toUpperCase() + editableDataSet?.["description"]?.slice(1).toLocaleLowerCase()}`) return true;
              return option.value.toUpperCase().indexOf(inputValue.toUpperCase()) > -1;
            }
            }
            onClear={e => {
              reasonAutocomplete.current.focus();
            }}
            onSelect={ (el) => {                                   
              const currentEl = el.split("-");
              const currentId = currentEl?.[0].trim();
              let currentItem = withHoldings.find(el => el.code === currentId);  
              /*
              editableDataSet["reasonId"] = currentItem.reasonId;
              editableDataSet["description"] = currentItem.description;
              editableDataSet["cuReason"] = currentItem.cuReason;
              */
              
              setModifiedFields({ ...modifiedFields, cuReason: currentItem.cuReason,
                withholdingRate: currentItem.withholdingRate, reasonId:  currentItem.reasonId, description: currentItem.description });
              dispatch(updateWithholding(
                draftId,
                withholdingUuId,
                {
                  cashContribution: editableDataSet["cashContribution"],
                  description: currentItem.description,
                  reasonId: currentItem.code,
                  cuReason: currentItem.cuReason,
                  withholdingRate: currentItem.withholdingRate,
                  totalNetAmount: totalTaxable,
                  notIncomeAmount: editableDataSet["notIncomeAmount"]             
                }
              )).then(() => {                
                dispatch(getWithholdingsList(draftId));
                dispatch(getWithholdingEditableFields(draftId,
                  withholdingUuId)).then(res => setEditable(res)).then(() => {    
                       
                  dispatch(getWithholdingNonEditableFields({...withholdingDrawer, totalNetAmount: totalTaxable})).then(() =>{
                    setIsLoadingDrawer(false);
                  });
                });
              });

            }}
            placeholder={"Cerca ritenuta"}
          />

        </WithHoldingDrawerField>);
    } 
    return field?.type === "toggle" ? (
      <div style={{ textAlign: "center" }}>
        <Switch  checked={editableDataSet?.[field?.id] } onChange={(val) => {
          editableDataSet[field?.id] = val;
          setModifiedFields({ ...modifiedFields, [field?.id]: val});
        }} />
        <span style={{ marginLeft: "16px" }}>
          <FormattedMessage id={`preCog.withholdingsTab.drawer.fields.${field?.id}`} />
        </span>
      </div>
    ) : (
      <div>
        <WithHoldingDrawerField
          field={field}
          position={"left"}
          width={"100%"}
          label={<FormattedMessage id={`preCog.withholdingsTab.drawer.fields.${field?.id}`} />}
        >
          {renderFormItem(field)}
        </WithHoldingDrawerField>
      </div>
    );
    
  };

  const currentObjectContent = drawerContentSwitch === "IRPEF" ? withHoldingDetailFields : withHoldingDetailFieldsInps;
  return currentObjectContent.rows.map((row, index) => {
    return <><div className="flexContentDrawer">

      <div>
        {row.col_1.map((field) => {          
          return renderInputOrInfo(field);
        })}
      </div>
      <div>
        {row.col_2.map((field) => {
          return renderInputOrInfo(field);
        })}
      </div>

    </div>{index<currentObjectContent.rows.length -1 && <hr style={{ width: "100%", borderTop: "1px solid #c9d9e8"}} />}</>;
  });
};

export default ContentWitholding;
